import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DynamicFieldModel } from '@share';
import { LoadingService } from 'src/app/share/services/loading.service';
import { PriceChangeHistoryService } from './price-change-history.service';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { ExcelService } from 'src/app/share/services/excel.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-price-change-history',
  imports: [DynamicTableComponent],
  providers: [DatePipe],
  templateUrl: './price-change-history.component.html',
  styleUrl: './price-change-history.component.scss'
})
export class PriceChangeHistoryComponent implements OnInit {
  private itemId: string = null;
  constructor(private datePipe: DatePipe, private readonly activatedRoute: ActivatedRoute, private readonly service: PriceChangeHistoryService, private readonly loadingService: LoadingService, private readonly cdr: ChangeDetectorRef, private readonly excelService: ExcelService) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    forkJoin({
      gp: this.service.getGroupItems(),
      main: this.service.getMainCategoryItems(),
      cat: this.service.getCategoryItems(),
      sub: this.service.getSubCategoryItems() // Add more API calls here if needed
    })
      .subscribe({
        next: ({ gp, main, cat, sub }) => {
          this.schema.columns[2].option = gp?.data.map((y: any) => ({
            text: y.group_name,
            value: y.group_name
          }));
          this.schema.columns[3].option = main?.data.map((y: any) => ({
            text: y.maincategory_name,
            value: y.maincategory_name
          }));
          console.log(this.schema.columns[3].option);
          this.schema.columns[4].option = cat?.data.map((y: any) => ({
            text: y.category_name,
            value: y.category_name
          }));
          this.schema.columns[5].option = sub?.data.map((y: any) => ({
            text: y.subcategory_name,
            value: y.subcategory_name
          }));
        },
        error: err => console.log(err),
        complete: () => {
          // this.loadingService.toggleTableLoading();
          // this.cdr.detectChanges();
        }
      });
    this.activatedRoute.params.subscribe((params: Params) => {
      this.itemId = params['id'];
      if (this.itemId) {
        let params = new HttpParams()
          .set('filterValue', JSON.stringify({ item_id: this.itemId }))
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      }
      else {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      }
    });

  }
  total = 0;
  schema = {
    name: "Price Change History",
    permissionKey: "pricechange",
    enableDelete: false,
    enableEdit: false,
    enableAdd: false,
    enableDownload: false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px"

      },
      {
        key: "item_name",
        title: "Name",
        type: "string",
        width: "200px",
        enableSearch: true,
        searchType: "input",

      },
      {
        key: "group_name",
        title: "Group",
        type: "string",
        width: "200px",
        enableSearch: true,
        //searchType: "input",
        searchType: "select",
        option: [],

      },
      {
        key: "maincategory_name",
        title: "Main Category",
        type: "string",
        width: "230px",
        enableSearch: true,
        //searchType: "input",
        searchType: "select",
        option: [],

      },
      {
        key: "category_name",
        title: "Category",
        type: "string",
        width: "200px",
        enableSearch: true,
        //searchType: "input",
        searchType: "select",
        option: [],

      },
      {
        key: "subcategory_name",
        title: "Item-Category",
        type: "string",
        width: "200px",
        enableSearch: true,
        //searchType: "input",
        searchType: "select",
        option: [],

      },
      // {
      //   key: "itemmetric.name",
      //   title: "Matric",
      //   type: "object",
      //   width: "200px",
      //   enableSearch: true,
      //   searchType: "input",

      // },
      {
        key: "old_price",
        title: "Old Price",
        type: "string",
        enableSearch: true,
        // searchType: "input",
        //enableSort: true,
        width: "200px",
      },
      {
        key: "new_price",
        title: "New Price",
        type: "string",
        // enableSearch: true,
        //enableSort: true,
        searchType: "input",
        width: "200px",
      },
      {
        key: "status",
        title: "Status",
        type: "status",
        enableSearch: true,
        searchType: "select",
        option: [{ value: 1, text: "UnChange" }, { value: 2, text: "Up" }, { value: 3, text: "Down" }],
        width: "150px",

      },
      {
        key: "createdAt",
        title: "Date",
        type: "date",
        enableSearch: true,
        searchType: "Date",
        width: "150px",

       },
      //  {
      //    key: "action",
      //    title: "Actions",
      //    type: "button",
      //    width: "150px",
      //    isStickyRight: true,
      //    isStickyLeft: false,
      //  },
     ]
  };
  fieldConfig: Array<DynamicFieldModel> = [
  ];

  report = {
    name: "Price Change History Report",
    file_name: "Price_Change_History_Report",
    header: [
      {
        label: "No",
        fieldName: "no",
        tag: "no",
        width: 5
      },
      {
        label: "Item Name",
        fieldName: "item_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Group Name",
        fieldName: "group_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Main Category",
        fieldName: "maincategory_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Category",
        fieldName: "category_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Item-Category",
        fieldName: "subcategory_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Old Price",
        fieldName: "old_price",
        class: "align-left",
        width: 20
      },
      {
        label: "New Price",
        fieldName: "new_price",
        class: "align-left",
        width: 20
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 20
      },
      {
        label: "Date",
        fieldName: "createdAt",
        tag: "datetime",
        class: "align-left",
        width: 20
      },
    ]
  };

  list: any[] = [];
  currentTime: Date = new Date();

  getCellValue(row: any, column: any): string {
    if (column.fieldName === "eng_version") {
      if (row[column.fieldName]) {
        return 'mm , en';
      }
      else {
        return 'mm'
      }
    }
    if (column.getDisplayValue) return column.getDisplayValue(row);
    if (!row[column.fieldName.split('.')[0]]) return ''
    const result: string = column.fieldName
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    if (column.pipe) {
      switch (column.pipe) {
        case 'shortDateTime': {
          return this.datePipe.transform(result)
        }
      }
    }

    return result
  }

  change(data: { [key: string]: any }) {
    if (data['type'] == 'download') {
      let params = new HttpParams()
        .set('filterValue', JSON.stringify(data['filters']));
      if (this.itemId) {
        params = params.set('filterValue', JSON.stringify({ ...data['filters'], item_id: this.itemId }));
      }
      this.loadingService.toggleTableLoading()
      this.service.getItems(params).subscribe({
        next: x => {
          let data = x.data;
          if (data !== undefined && data.length !== 0) {
            const value = []
            for (let i = 0; i < data?.length; i++) {
              const item: any = {}
              for (const row of this.report.header) {
                const head = row
                if (!head.hasOwnProperty('objFieldName')) {
                  if (head.tag === 'no') item[head.label] = i + 1
                  else if (head.tag === 'number')
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : 0
                  else if (head.tag === 'pipe') {
                    const [field1, field2] = head.fieldName.split('|');
                    const value = data[i][field1];
                    item[head.label] = value !== '' && value != null
                      ? value
                      : data[i][field2] ?? '';
                  }
                  else if (head.tag === 'datetime') {
                    item[head.label] = data[i][head.fieldName]
                      ? this.datePipe.transform(new Date(data[i][head.fieldName]),'dd-MM-yyyy HH:mm')
                      : ''
                  }
                  else
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : ''
                }else {
                  item[head.label] =
                    data[i][head.fieldName] !== null
                      ? this.getCellValue(data[i], head)
                      : ''
                }
              }
              value.push(item)
            }
            const dynamicName = `${this.report.file_name
            }_${this.currentTime.getDate()}_${this.currentTime.getMonth() + 1
            }_${this.currentTime.getFullYear()}`;
            this.excelService.exportAsExcelFile(
              value,
              dynamicName,
              this.report.header
            )
          }
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
    else {
      if (this.itemId) {
        data['filters'] = Object.assign(data['filters'], { item_id: this.itemId })
      }
      console.log(JSON.stringify(data));
      let params = new HttpParams()
        //.set('searchValue',this.searchValue)
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));
      this.loadData(params);
    }
  }

  loadData(param: HttpParams = null, needLoading: boolean = true) {
    if (needLoading) {
      this.loadingService.toggleTableLoading();
    }
    this.service.getItems(param).subscribe({
      next: x => {
        this.list = x.data.map((row: any) => ({
          ...row,
          old_price: row.old_price ? `${row.old_price.min} - ${row.old_price.max}` : '',
          new_price: row.new_price ? `${row.new_price.min} - ${row.new_price.max}` : ''
        }));
        this.total = x.totalCount;
      },

      error: err => this.loadingService.toggleTableLoading(),
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }
}
